import { render, staticRenderFns } from "./activity-response-modal.vue?vue&type=template&id=97b2460e&scoped=true&"
import script from "./activity-response-modal.vue?vue&type=script&lang=js&"
export * from "./activity-response-modal.vue?vue&type=script&lang=js&"
import style0 from "./activity-response-modal.vue?vue&type=style&index=0&id=97b2460e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97b2460e",
  null
  
)

component.options.__file = "activity-response-modal.vue"
export default component.exports